//import 'bootstrap/dist/css/bootstrap.css';

import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import App from './App';
import { store } from './store';

const rootElement = document.getElementById('root');
if (rootElement === null) { throw new Error('Root element not found'); }
const root = createRoot(rootElement);
root.render(
  <Provider store={store}>
    <App />
  </Provider>
);